import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper'
import {dimensionQualityChecks, uomKg} from '../../Config/constants';

export default function QualityCheckDetailOverviewTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [VNG, setVNG] = useState(false)

    const colums = props.qualitySamples.sort((a, b) => new Date(b.samples[0].date) - new Date(a.samples[0].date)).map(x => {

        var sequence = 1
        if (x.carrierInfo.bookingSequence === -1) {
            sequence = "*VNG"
            if(!VNG){
                setVNG(true)
            }
        }
        else {
            sequence = sequence + x.carrierInfo.bookingSequence         
        }
        return (createColums(fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date), sequence))
    }
    )

    function createColums(date, palletSequence) {

        return { date, palletSequence };
    }

    const rows = props.qualitySamples[0].samples.map(x => createRows(x.description, x.code))

    function createRows(description, code) {
        return { description, code };
    }

    const getValue = (code, date) => {

        var sampleValue = props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).sampleValue
        if (sampleValue === null) {
            return props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).resultOk
        }
        else {
            if(props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).description === dimensionQualityChecks.GEWICHT){
                if(props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).uom.includes(uomKg)){
                   
                    return parseFloat(sampleValue).toFixed(3)
                }
                else{
                    return parseInt(sampleValue)
                }
            }
            else{
                return parseFloat(sampleValue).toFixed(2)
            }
        }
    }

    const getLastColumnWidth = () => {
        // let count = props.qualityCheck.qualityCheckOrders.filter(y => String(y.orderId) === props.orderId).length
        // let width = String(90 - count * 4) + "%"
        // return width
    }

    const getSequenceColor = (detailDate) => {
        let qualityChecks = props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === detailDate)
        var i;
        var resultOK = true;
        for (i = 0; i < qualityChecks.samples.length; i++) {
            if (!qualityChecks.samples[i].resultOk) {
                resultOK = false;
            }
        }
        if (!resultOK) {
            return "#D84949"
        }
        if (props.detailDate === detailDate) {
            return FlagstoneTheme.palette.primary.main
        }
        return '#020100'
    }

    const errorCellRequired = (code, date) => {

        if (props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).sampleValue === null) {
            return false;
        }
        else {
            return !props.qualitySamples.find(x => fromNewDateFormatToDDMMYYYYHHmmssSlash(x.samples[0].date) === date).samples.find(y => y.code === code).resultOk
        }
    }

    return (
        <div className={classes.qualityChecksTable}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.firstHeadCell}></TableCell>
                        {colums.map((column, index) => (
                            <TableCell key={index} className={clsx({ [classes.detailHeadCell]: props.detailDate === column.date, [classes.headCell]: props.detailDate !== column.date })}>
                                <div className={classes.palletSequence} style={{ color: getSequenceColor(column.date), textShadow: getSequenceColor(column.date) === "#D84949" && "0 0 5px #D84949", fontWeight: getSequenceColor(column.date) === "#D84949" && "bold" }}>{column.palletSequence}</div>
                                <div className={classes.date} style={{ marginTop: column.palletSequence === "" ? "45px" : "20px" }}>{column.date}</div>
                            </TableCell>
                        ))}
                        <TableCell className={classes.lastHeadCell} style={{ width: getLastColumnWidth() }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.code} className={classes.row}>
                            <TableCell className={classes.firstInfoCell}>{row.description}</TableCell>
                            {colums.map((column) => (
                                <TableCell className={clsx({ [classes.errorCell]: errorCellRequired(row.code, column.date), [classes.detailCell]: props.detailDate === column.date, [classes.infoCell]: props.detailDate !== column.date })} style={{ boxShadow: props.detailDate === column.date && "inset 10px 0 9px -7px rgba(0,0,0,0.2)" }}>
                                    {getValue(row.code, column.date) === false ? <svg className={classes.check} xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 121.31 122.876" enableBackground="new 0 0 121.31 122.876"><g><path fillRule="evenodd" fill="#D84949" clipRule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z" /></g></svg>
                                        : getValue(row.code, column.date) === true ? <img className={classes.check} src={process.env.PUBLIC_URL + '/img/greenCheck.svg'} alt={""}></img>
                                            : getValue(row.code, column.date)}
                                </TableCell>
                            ))}
                            <TableCell className={classes.lastInfoCell} style={{ width: getLastColumnWidth() }}></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {VNG && <div className = {classes.vng}>{t("* Volgnummer niet gekend, volgnummer wordt uitgereikt na de boeking van de pallet")}</div>}
        </div>
    )
}

const useStyles = makeStyles({
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    qualityChecksTable: {
        backgroundColor: "white",
        padding: "10px",
        paddingTop: "0px",
        borderRadius: "6px",
        marginLeft: "5px",
        overflowX: "auto"
    },
    infoCell: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "10px",
        paddingTop: "10px",
        width: "4%",
        textAlign: "center",
        borderRight: "1px solid #DEDEDE"
    },
    detailCell: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "10px",
        paddingTop: "10px",
        width: "4%",
        textAlign: "center",
        backgroundColor: "#E6E8FE8B",
        borderRight: "1px solid #DEDEDE"
    },
    errorCell: {
        color: 'white',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        borderTop: "1px solid white",
        paddingBottom: "10px",
        paddingTop: "10px",
        width: "4%",
        textAlign: "center",
        backgroundColor: "#D84949",
        borderRight: "1px solid #DEDEDE"
    },
    firstInfoCell: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "10px",
        paddingTop: "10px",
        width: "10%",
        borderRight: "1px solid #DEDEDE"
    },
    headCell: {
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "0px",
        height: "150px",
        width: "4%",
        borderRight: "1px solid #DEDEDE"
    },
    detailHeadCell: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "0px",
        height: "150px",
        width: "4%",
        backgroundColor: "#E6E8FE8B",
        boxShadow: "inset 10px 0 9px -7px rgba(0,0,0,0.2)",
        borderRight: "1px solid #DEDEDE"
    },
    firstHeadCell: {
        height: "150px",
        width: "10%",
        borderRight: "1px solid #DEDEDE"
    },
    check: {
        width: "20px"
    },
    palletSequence: {
        color: '#000000',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textAlign: 'center'
    },
    date: {
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textAlign: 'center',
        marginBottom: "10px",
    },
    vng:{
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        paddingTop:"10px"
    }

});